<template>
  <div>
    <AlertDismiss ref="alertDismiss" class="mx-2"></AlertDismiss>

    <b-table ref="table" :busy="isBusy" :fields="fields" :items="items" no-border-collapse responsive
             show-empty
             sticky-header="60vh">

      <template #empty>
        <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
          No hay plantillas que coincidan con los criterios de búsqueda
        </b-card>
        <b-card v-else class="text-center my-2 fs-5">
          Aún no se ha agregado ninguna plantilla
        </b-card>
      </template>

      <!--icono de carque de tabla-->
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Cargando datos de tabla...</strong>
        </div>
      </template>

      <template #cell(details)="row">
        <b-button class="mr-2" size="sm" variant="outline-secondary" @click="row.toggleDetails">
          <div v-if="row.detailsShowing">
            <span class="d-none d-md-inline me-2">Ocultar</span>
            <b-icon font-scale="1" icon="eye-slash-fill"></b-icon>
          </div>
          <div v-else>
            <span class="d-none d-md-inline me-2">Ver</span>
            <b-icon font-scale="1" icon="eye-fill"></b-icon>
          </div>
        </b-button>
      </template>

      <template #row-details="row">
        <b-card>
          <div>
            <b>Preguntas de la plantilla</b>
            <ol class="m-0">
              <li v-for="question in row.item.questions" :key="question.id">
                <span>{{ question.name }}
                  <div v-if="question.deepening"
                       v-b-tooltip.hover.right
                       class="abbreviation ms-1 text-info"
                       title="Require una explicación en caso de contestarse afirmativamente"
                  >
                    <b-icon font-scale="1" icon="question-circle"></b-icon>
                  </div></span>
              </li>
            </ol>
          </div>
        </b-card>
      </template>

      <template #cell(document)="row">
        <button v-b-tooltip.hover.right class="btn btn-light btn-sm" title="Ver documento"
                @click="openDocument(row)">
          <b-icon font-scale="1" icon="file-earmark" variant="primary"></b-icon>
        </button>
      </template>
    </b-table>

    <BaseModal v-model="modalShowDocument" size="xl">
      <DocumentPdf :pdfUrl="documentUrl"></DocumentPdf>
    </BaseModal>

  </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import {EventNames} from '@/plugins/enums/index.js'
import {mapActions} from 'vuex';
import {formatDateTime} from '@/plugins/complianceScripts/index.js';
import BaseModal from "@/components/shared/Base-modal.vue";
import DocumentPdf from "@/components/shared/Document-pdf.vue";

export default {
  name: 'StatementTemplateList',

  components: {
    AlertDismiss,
    BaseModal,
    DocumentPdf
  },

  data() {
    return {
      isBusy: false,
      modalShowDocument: false,

      fields: [
        {key: 'name', label: 'Nombre'},
        {key: 'creationDate', label: 'Fecha de creación', formatter: formatDateTime},
        {key: 'details', label: 'Detalle', thClass: 'col-2'},
        {key: 'document', label: 'Opciones', thClass: 'col-2'},
      ],

      selected: [],

      items: [],

      documentUrl: ""
    }
  },

  async mounted() {
    this.getAll();

    this.$eventBus.$on(EventNames.CreatedStatementTemplate, async () => {
      await this.getAll();
    });
  },

  methods: {
    ...mapActions(["getAllStatementTemplates", "getTemplateDocumentUrl"]),
    
    async getAll() {
      this.isBusy = true;
      let result = await this.getAllStatementTemplates();

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        this.isBusy = false;
        return;
      }

      this.items = result.data;
      this.isBusy = false;
    },

    async openDocument(row) {
      let route = row.item.document.route
      this.modalShowDocument = true;
      let result = await this.getTemplateDocumentUrl({route});
      if (result.isError) {
        this.modalShowDocument = false;
        this.$refs.alertDismiss.showAlert(result.message);
        return;
      }
      this.documentUrl = result.data;
    },
  }
}
</script>
<style>

.abbreviation {
  display: inline;
  font-weight: bold;
  font-family: monospace;
}

</style>
